import { render, staticRenderFns } from "./CustomerCardsModal.vue?vue&type=template&id=422e381c&scoped=true"
import script from "./CustomerCardsModal.vue?vue&type=script&lang=js"
export * from "./CustomerCardsModal.vue?vue&type=script&lang=js"
import style0 from "./CustomerCardsModal.vue?vue&type=style&index=0&id=422e381c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422e381c",
  null
  
)

export default component.exports